import React from 'react';
import PropTypes from 'prop-types';
import theme from '@splashthat/sui/lib/theme';

const BASE_COLOR = theme.palette.grayscale.black;
const MAX_ADMITTED_HEIGHT = 10;

const getTopHeight = (height) => (height > MAX_ADMITTED_HEIGHT ? MAX_ADMITTED_HEIGHT : height);

const BorderPickerDropdownOption = ({ height }) => (
    <div className={'BorderPickerDropdownOption__container'}>
        <div
            style={{
                height: getTopHeight(height),
                backgroundColor: BASE_COLOR,
            }}
        />
    </div>
);

BorderPickerDropdownOption.propTypes = {
    height: PropTypes.number.isRequired,
};

export default BorderPickerDropdownOption;
